<template>
  <div>
    <VCard
      :elevation="$vuetify.breakpoint.smAndDown ? 0 : 1"
      :color="$vuetify.breakpoint.smAndDown ? 'transparent' : '#ffffff'"
      class="pa-3 pa-md-7 px-md-12 mb-5"
    >
      <h1 class="display-2">
        {{ company.name }}
      </h1>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="mt-6 font-weight-regular body-2" v-html="company.about" />
    </VCard>
    <VCard
      v-if="company.officePhotos.length"
      elevation="1"
      class="pa-3 pb-1 pa-md-7 px-md-2 mb-5"
    >
      <h3
        class="d-flex justify-space-between align-end px-md-10"
        :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'title'"
      >
        {{ $t('officePictures') }}
        <span class="body-2 grey--text text--lighten-1 mb-1">
          {{ $tc('photo', company.officePhotos.length) }}
        </span>
      </h3>
      <AppPhotoGallery
        :photos="company.officePhotos"
        class="mt-2 mx-n3"
      />
    </VCard>
    <div v-else />
  </div>
</template>

<script>
import AppPhotoGallery from '../AppPhotoGallery.vue';

export default {
  name: 'CompanyCard',
  components: { AppPhotoGallery },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  officePictures: Office photos
  photo: 0 photos | {n} photo | {n} photos | {n} photos

</i18n>

<i18n locale="ru" lang="yaml">
  officePictures: Фото офиса
  photo: 0 фотографий | {n} фотография | {n} фотографии | {n} фотографий
</i18n>
